import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { MeetingNote, UploadMeetingNoteRequest } from '@models/meeting-notes.model';

@Injectable({
  providedIn: 'root',
})
export class MeetingNotesService {
  private readonly baseUrl = `${environment.apiUrl}/MeetingNotes`;

  constructor(private http: HttpClient) {}

  getMeetingNotes(organizationId: number): Observable<MeetingNote[]> {
    return this.http.get<MeetingNote[]>(`${this.baseUrl}`, {
      params: { organizationId: organizationId.toString() },
    });
  }

  uploadMeetingNote(req: UploadMeetingNoteRequest): Observable<MeetingNote> {
    const formData = new FormData();
    formData.append('organizationId', req.organizationId.toString());
    formData.append('meetingDescription', req.meetingDescription);
    formData.append('meetingDate', req.meetingDate);
    formData.append('sendNotification', req.sendNotification.toString());
    formData.append('file', req.file, req.file.name);
    return this.http.post<MeetingNote>(`${this.baseUrl}`, formData);
  }

  deleteMeetingNote(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  viewMeetingNote(id: number, organizationId: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/view`, {
      responseType: 'blob',
      params: { organizationId: organizationId.toString() },
    });
  }
}
